import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { User } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

const ProfileAvatar = ({ userId = null, size = 'md', testId = 'avatar' }) => {
  const [blobUrl, setBlobUrl] = useState(null);
  const [facePhotoId, setFacePhotoId] = useState(null);

  const endpoint = userId ? `${API}/api/profile/${userId}` : `${API}/api/profile`;

  useEffect(() => {
    let cancelled = false;
    let localUrl = null;

    const load = async () => {
      try {
        const { data } = await axios.get(endpoint, { withCredentials: true });
        if (cancelled) return;
        setFacePhotoId(data.face_photo_id || null);
        if (data.face_photo_id) {
          const res = await axios.get(`${API}/api/files/${data.face_photo_id}`, {
            withCredentials: true,
            responseType: 'blob',
          });
          if (cancelled) return;
          localUrl = URL.createObjectURL(res.data);
          setBlobUrl(localUrl);
        }
      } catch (error) {
        // Silent — avatar is optional
      }
    };
    load();
    return () => {
      cancelled = true;
      if (localUrl) URL.revokeObjectURL(localUrl);
    };
  }, [endpoint]);

  const sizeClass = size === 'lg' ? 'w-12 h-12' : size === 'sm' ? 'w-8 h-8' : 'w-10 h-10';
  const iconSize = size === 'lg' ? 'w-6 h-6' : size === 'sm' ? 'w-4 h-4' : 'w-5 h-5';

  if (blobUrl) {
    return (
      <img
        src={blobUrl}
        alt="Profile"
        className={`${sizeClass} rounded-full object-cover border-2 border-blue-100`}
        data-testid={testId}
      />
    );
  }

  return (
    <div className={`${sizeClass} bg-blue-100 rounded-full flex items-center justify-center`} data-testid={testId}>
      <User className={`${iconSize} text-blue-600`} />
    </div>
  );
};

export default ProfileAvatar;
